/** Ficha da reforma tributária (IBS/CBS) por cliente: questionário, ações recomendadas e tarefas de adequação. */
import { z } from 'zod';
import { Id } from './comum.js';

export const RespostaReforma = z.enum(['SIM', 'NAO', 'NAO_SEI', 'EMPRESAS', 'CONSUMIDOR', 'AMBOS', 'PARCIAL', 'NAO_EMITE']);
export const PrioridadeReforma = z.enum(['ALTA', 'MEDIA', 'BAIXA']);
export type PrioridadeReforma = z.infer<typeof PrioridadeReforma>;
export const PerguntaReforma = z.object({ id: z.string(), texto: z.string(), ajuda: z.string().optional(), opcoes: z.array(z.tuple([RespostaReforma, z.string()])) });
export type PerguntaReforma = z.infer<typeof PerguntaReforma>;
export const AcaoReforma = z.object({ id: z.string(), titulo: z.string(), porque: z.string(), prioridade: PrioridadeReforma, departamento: z.string(), /** tarefa de adequação já criada para esta ação */ tarefaId: Id.nullable(), tarefaStatus: z.string().nullable() });
export type AcaoReforma = z.infer<typeof AcaoReforma>;

export const ReformaFicha = z.object({
  clienteId: Id, clienteNome: z.string(), documento: z.string(), regime: z.string().nullable(),
  respostas: z.record(z.string(), RespostaReforma),
  observacao: z.string().nullable(),
  respondidas: z.number().int(), totalPerguntas: z.number().int(),
  acoes: z.array(AcaoReforma),
  nivel: PrioridadeReforma.nullable(),
  atualizadoEm: z.string().nullable(), atualizadoPor: z.string().nullable(),
});
export type ReformaFicha = z.infer<typeof ReformaFicha>;
export const ReformaFichaBody = z.object({ respostas: z.record(z.string().max(40), RespostaReforma), observacao: z.string().trim().max(2000).nullable().optional() });
export type ReformaFichaBody = z.infer<typeof ReformaFichaBody>;

export const ReformaLinha = z.object({ clienteId: Id, clienteNome: z.string(), documento: z.string(), regime: z.string().nullable(), respondidas: z.number().int(), nivel: PrioridadeReforma.nullable(), acoes: z.number().int(), acoesComTarefa: z.number().int(), atualizadoEm: z.string().nullable() });
export const ReformaPainel = z.object({ perguntas: z.array(PerguntaReforma), linhas: z.array(ReformaLinha), resumo: z.object({ clientes: z.number().int(), respondidas: z.number().int(), alta: z.number().int(), semFicha: z.number().int() }) });
export type ReformaPainel = z.infer<typeof ReformaPainel>;
export const ReformaTarefasResultado = z.object({ criadas: z.number().int(), jaExistiam: z.number().int() });
